"use client";

import * as React from 'react';
import classNames from 'classnames';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalFooter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    bsPrefix,
    as: Component = 'div',
    ...props
  } = _ref;
  bsPrefix = useBootstrapPrefix(bsPrefix, 'modal-footer');
  return /*#__PURE__*/_jsx(Component, {
    ref: ref,
    className: classNames(className, bsPrefix),
    ...props
  });
});
ModalFooter.displayName = 'ModalFooter';
export default ModalFooter;